import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { processColorMode } from "../../theme/colors";
import { Fonts, FontWeight, LineHeights } from "../../theme/enums";
export const Quote = ({ typeSize = "pullout", mode = "light", useRule = false, lang = "en", children }) => {
    const pulloutSize = ["scale4", "scale4", "scale4", "scale6", "scale8"];
    const inlineSize = ["scale1", "scale1", "scale2", "scale2"];
    const processTypeSize = (ts) => {
        switch (ts) {
            case "inline":
                return inlineSize;
            case "pullout":
                return pulloutSize;
            default:
                return pulloutSize;
        }
    };
    return (_jsx(Flex, { sx: Object.assign(Object.assign({}, processColorMode(mode)), { width: "100%", flex: 1, borderTopStyle: "solid", borderTopWidth: useRule ? "1px" : "0px" }), children: _jsx(Box, { sx: {
                pt: useRule ? [24, null, null, 32, 48] : 0
            }, children: _jsx("blockquote", { className: "color-mode-title", lang: lang, sx: {
                    fontFamily: typeSize === "inline" ? Fonts.text : Fonts.display,
                    fontWeight: typeSize === "inline"
                        ? FontWeight.textRegular
                        : FontWeight.displayRegular,
                    lineHeight: typeSize === "inline"
                        ? LineHeights.editorial
                        : LineHeights.heading,
                    fontSize: processTypeSize(typeSize),
                    maxWidth: typeSize === "pullout" ? ["90ch"] : ["42ch"],
                    quotes: "auto",
                    display: "flex",
                    ":before": {
                        fontFamily: typeSize === "inline" ? Fonts.text : Fonts.display,
                        fontWeight: typeSize === "inline"
                            ? FontWeight.textRegular
                            : FontWeight.displayRegular,
                        content: typeSize === "pullout" ? "open-quote" : "none"
                    },
                    ":after": {
                        fontFamily: typeSize === "inline" ? Fonts.text : Fonts.display,
                        fontWeight: typeSize === "inline"
                            ? FontWeight.textRegular
                            : FontWeight.displayRegular,
                        content: typeSize === "pullout" ? "close-quote" : "none",
                        display: "contents",
                        alignSelf: "flex-end"
                    }
                }, children: children }) }) }));
};
//# sourceMappingURL=Quote.js.map